"use client";

import { c as _c } from "react/compiler-runtime";
import { motion, useMotionValue, useReducedMotion } from "framer-motion";
import { useEffect, useRef, useState } from "react";

// A circle that trails the cursor and grows (with an optional label) over any
// link, button, or element marked with data-cursor. Desktop/fine-pointer only.
export const CustomCursor = () => {
  const $ = _c(20);
  const reduce = useReducedMotion();
  const [enabled, setEnabled] = useState(false);
  const [active, setActive] = useState(false);
  const [label, setLabel] = useState("");
  const activeRef = useRef(false);
  const labelRef = useRef("");
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  let t0;
  let t1;
  if ($[0] !== reduce || $[1] !== x || $[2] !== y) {
    t0 = () => {
      if (reduce || !window.matchMedia("(pointer: fine)").matches) {
        return;
      }
      setEnabled(true);
      document.body.style.cursor = "none";
      const move = e => {
        x.set(e.clientX);
        y.set(e.clientY);
        const el = (e.target as HTMLElement | null)?.closest("a, button, [data-cursor]");
        const nextActive = Boolean(el);
        const nextLabel = el?.getAttribute("data-cursor-label") ?? "";
        if (nextActive !== activeRef.current) {
          activeRef.current = nextActive;
          setActive(nextActive);
        }
        if (nextLabel !== labelRef.current) {
          labelRef.current = nextLabel;
          setLabel(nextLabel);
        }
      };
      window.addEventListener("mousemove", move);
      return () => {
        window.removeEventListener("mousemove", move);
        document.body.style.cursor = "";
      };
    };
    t1 = [reduce, x, y];
    $[0] = reduce;
    $[1] = x;
    $[2] = y;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  if (!enabled) {
    return null;
  }
  let t2;
  if ($[5] !== x || $[6] !== y) {
    t2 = {
      x,
      y
    };
    $[5] = x;
    $[6] = y;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const t3 = active ? 72 : 14;
  const t4 = active ? 72 : 14;
  const t5 = active ? "rgba(22,235,90,0.12)" : "rgba(22,235,90,1)";
  let t6;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = {
      width: t3,
      height: t4,
      backgroundColor: t5
    };
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      type: "spring",
      stiffness: 250,
      damping: 22
    };
    t8 = {
      x: "-50%",
      y: "-50%"
    };
    $[12] = t7;
    $[13] = t8;
  } else {
    t7 = $[12];
    t8 = $[13];
  }
  const t9 = active && label;
  let t10;
  if ($[14] !== t6 || $[15] !== t9) {
    t10 = <motion.div animate={t6} transition={t7} style={t8} className="flex items-center justify-center rounded-full border border-primary text-[11px] font-semibold uppercase tracking-wide text-primary">{t9}</motion.div>;
    $[14] = t6;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t2) {
    t11 = <motion.div aria-hidden={true} style={t2} className="pointer-events-none fixed left-0 top-0 z-[200]">{t10}</motion.div>;
    $[17] = t10;
    $[18] = t2;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
};